module.exports = "<p>list-map-new works!</p>\n"